<template>
  <div class="services">
    <div v-for="(category, keyLabel) in services" :key="keyLabel" class="catergory-box" v-show="showServiceViaCategory(keyLabel) && !quoteLegLoading[leg]">
      <div class="catergory-label" v-if="keyLabel !== 'zznot_applicable'">{{keyLabel}}</div>
      <div v-for="service in category" :key="service.code" :class="keyLabel">
        <div class="service-box" v-show="showService(service.code)">
          <div @click="selectService(service.code)"
            :class="['service row', {loading:loading, disabled:serviceDisable(service.code), active:selectedService === service.code}]">

            <div class="column medium-2 service-img">
              <div class="medium-below">
                <div class="ribbon lowest" v-if="ribbon(service.code).lowest && ribbonShow.lowest">
                  <img src="../../assets/img/lowest.png" />
                  <span>{{ $t('serviceSelect.bestValue') }}</span>
                </div>

                <div class="ribbon fastest" v-if="ribbon(service.code).fastest && ribbonShow.fastest">
                  <img src="../../assets/img/fastest.png" />
                  <span>{{ $t('serviceSelect.fastest') }}</span>
                </div>
              </div>
              <img :src="service.img" />
            </div>

            <div class="column medium-10 service-data-box">
              <div class="service-data">
                <div class="row">
                  <div class="medium-8 column">
                    <div class="service-max-paxluggage">
                      <div :class="{'pax-luggage':true, 'reach-max':maxPax[service.code]}">
                        <div class="fa-stack">
                          <i class="fas fa-circle fa-stack-2x"></i>
                          <i class="fas fa-user fa-stack-1x fa-inverse"></i>
                        </div>
                        <span>{{ service.maxPaxLabel }}</span>
                      </div>
                      <div :class="{'pax-luggage':true, 'reach-max':maxLuggage[service.code]}">
                        <div class="fa-stack">
                          <i class="fas fa-circle fa-stack-2x"></i>
                          <i class="fas fa-suitcase fa-stack-1x fa-inverse"></i>
                        </div>
                        <span>{{ service.maxLuggageLabel }}</span>
                      </div>
                    </div>

                    <div class="medium-below small-12 column">
                      <div class="service-name">
                        {{ service.label }}
                        <span v-if="service.ribbonLabel" :class="['ribbon-label', service.ribbonLabel.class]">{{service.ribbonLabel.value}}</span>
                      </div>
                    </div>
                    <div class="medium-below small-12 column service-brand">
                      <div class="stairs-label" v-if="rsvpData.isAirportPickup && service.upDownstairs">{{ service.upDownstairs }}</div>
                    </div>

                    <div class="medium-below pricing">
                      <div v-if="availabilityInfo(service.code).enabled && availabilityInfo(service.code).eligible === 0"
                        class="availability-error">
                        {{ availabilityInfo(service.code).suggestedLabel }}
                        <span>{{ availabilityInfo(service.code).suggestedTime }}</span>
                      </div>
                      <div class="service-quote" v-else>
                        <div class="small-12 column">
                          <div class="service-price">
                            {{ price(service.code).price }}
                            <div class="one-way-fare plus">{{ $t('serviceSelect.plusApplicableFees') }}</div>
                            <div class="one-way-fare" v-if="!charter.enabled">{{ $t('serviceSelect.onewayFare') }}</div>
                            <div v-if="sharedNotAvaialble(leg, service.code)" class="shared-error">
                              <span v-if="sharedAllowTime.start !== sharedAllowTime.end">
                                {{
                                  $t('serviceSelect.serviceAirportAvailable1', {
                                    service: service.label,
                                    start: sharedAllowTime.start,
                                    end: sharedAllowTime.end,
                                  })
                                }}
                              </span>
                              <span v-else>
                                {{ $t('serviceSelect.serviceAirportAvailable2', {service: service.label}) }}
                              </span>
                            </div>
                            <transition name="slide-down">
                              <div v-if="showSuggestedService(leg, service.code)" class="suggested-service"
                                @click="selectService(nextAvailableService)">
                                {{ $t('serviceSelect.tryService', {service: serviceLabel(nextAvailableService)}) }}
                              </div>
                            </transition>
                            <div class="service-discount-info" v-if="leg === 'leg1' && !_isRoundtrip && !rsvpData.isAsap && (!_selectedService || (_selectedService && !rsvpData.pickupDate)) && price(service.code).rtPrice">
                              <div class="rt-dc-small">
                                <img src="../../assets/img/roundtrip-banner-small.png" />
                                <span>{{ price(service.code).rtPrice }}</span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="small-12 column margin-b-xs">
                          <div class="service-discount-info" v-if="price(service.code).saved > 0">
                            <span class="service-original-price">{{ price(service.code).original }}</span>
                            <span class="service-discount-saved">{{ $t('serviceSelect.save') }} {{currency.symbol}}{{ price(service.code).saved }}</span>
                          </div>
                          <div class="service-discount-timer" v-if="price(service.code).saved > 0">
                            <span>{{ $t('serviceSelect.discount') }}:</span>
                            <span class="timer">{{ discountTimeLeft }}</span>
                          </div>
                        </div>

                        <div class="small-12 column">
                          <div class="eta margin-t-s margin-b-m">
                            <div>
                              <span class="minutes-away" v-if="eta(service.code).minutesAway !== 999  && !sharedNotAvaialble(leg, service.code) && showEta">
                                {{ eta(service.code).minutesAway }} 
                                {{ $t('serviceSelect.minutesAway') }}
                              </span>
                              <span :class="['suggested-pickup-time', /*{'not-allowed':!suggestedPickupTime(service.code).isAllowed}*/]"
                                @click.stop
                                v-if="(rsvpData.isAirportPickup || rsvpData.isAirportDropoff) && !rsvpData.isAsap && suggestedPickupTime(service.code).val && !charter.enabled">
                                <div>Click here to Customize your schedule</div>
                                {{ $t('serviceSelect.pickupDate') }}
                                <a @click="customPickupTime(service.code)">
                                  {{ suggestedPickupTime(service.code).val }}
                                  <i class="fas fa-edit"></i>
                                </a>
                              </span>
                              <span class="dropoff-time" v-if="showBtt && !charter.enabled">
                                {{ $t('serviceSelect.dropoffTime') }}
                                {{ eta(service.code).dropoffTime }}
                              </span>
                            </div>
                            <div v-if="eta(service.code).minutesAway !== 999  && !sharedNotAvaialble(leg, service.code)"></div>
                            <div v-else-if="!sharedNotAvaialble(leg, service.code) && showEta && !charter.enabled">
                              <span class="no-cars">{{ $t('serviceSelect.bookAdvance') }}</span>
                            </div>
                            <div class="disabled-date" v-if="service.unavailableTime">Not available on the selected date</div>
                          </div>

                          <div class="mng margin-b-xs" v-if="hasMngOnly(service.code)">
                            {{ $t('serviceSelect.mng') }} 
                            {{ mngComplimentary[service.code].pickupFee === 0 ? '(' + $t('serviceSelect.complimentary')+  ')' : `${currency.symbol}${toFixed(mngComplimentary[service.code].pickupFee)}` }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="medium-above service-name">
                      {{ service.label }} <!-- {{service.id}}-->
                      <span v-if="service.ribbonLabel" :class="['ribbon-label', service.ribbonLabel.class]">{{service.ribbonLabel.value}}</span>
                    </div>
                    <div class="medium-above service-desc-excerpt" v-show="!showDesc[service.code]" v-html="service.excerpt"></div>
                    <transition name="fade">
                      <div class="service-desc" v-show="showDesc[service.code]">
                        <div v-html="service.desc" class="margin-b-s"></div>
                        <div v-html="service.advantage"></div>
                        <div v-if="!!service.stops" v-html="service.stops" class="margin-t-s"></div>
                        <div class="margin-t-s more-imgs-link" v-if="service.moreImgs.length">
                          <a @click="showMoreImgs(service)">{{ $t('serviceSelect.viewMoreImgs') }}</a>
                        </div>
                      </div>
                    </transition>

                    <div class="medium-below service-desc-more" v-if="!isLyftBooking">
                      <span @click.stop>
                        <a @click="toggleDescription(service.code)"
                          class="op-btn btn-block btn-success">
                          <span v-show="!showDesc[service.code]">{{ $t('serviceSelect.moreInfo') }}</span>
                          <span v-show="showDesc[service.code]">{{ $t('serviceSelect.hideInfo') }}</span>
                        </a>
                      </span>
                    </div>
                    <div class="medium-above service-desc-more margin-t-s" v-if="!isLyftBooking">
                      <span @click.stop>
                        <a @click="toggleDescription(service.code)">
                          <span v-show="!showDesc[service.code]">{{ $t('serviceSelect.moreInfo') }}</span>
                          <span v-show="showDesc[service.code]">{{ $t('serviceSelect.hideInfo') }}</span>
                        </a>
                      </span>
                    </div>
                  </div>

                  <div class="medium-4 column medium-above">
                    <div v-if="availabilityInfo(service.code).enabled && availabilityInfo(service.code).eligible === 0"
                      class="availability-error">
                      {{ availabilityInfo(service.code).suggestedLabel }}
                      <span>{{ availabilityInfo(service.code).suggestedTime }}</span>
                    </div>
                    <div class="service-quote" v-else>
                      <div class="service-price">
                        {{ price(service.code).price }}
                        <div class="one-way-fare plus">{{ $t('serviceSelect.plusAppFees') }}</div>
                        <div class="one-way-fare" v-if="!charter.enabled">{{ $t('serviceSelect.oneWayFare') }}</div>
                        <div class="stairs-label" v-if="rsvpData.isAirportPickup && service.upDownstairs">{{ service.upDownstairs }}</div>
                        <div v-if="sharedNotAvaialble(leg, service.code)" class="shared-error">
                          <span v-if="sharedAllowTime.start !== sharedAllowTime.end">
                            {{
                              $t('serviceSelect.serviceAirportAvailable1', {
                                service: service.label,
                                start: sharedAllowTime.start,
                                end: sharedAllowTime.end,
                              })
                            }}
                          </span>
                          <span v-else>
                            {{ $t('serviceSelect.serviceAirportAvailable2', {service: service.label}) }}
                          </span>
                        </div>
                        <transition name="slide-down">
                          <div v-if="showSuggestedService(leg, service.code)" class="suggested-service"
                            @click="selectService(nextAvailableService)">
                            {{ $t('serviceSelect.tryService', {service: serviceLabel(nextAvailableService)}) }}
                          </div>
                        </transition>
                      </div>

                      <div class="service-discount-info" v-if="price(service.code).saved > 0">
                        <span class="service-original-price">{{ price(service.code).original }}</span>
                        <span class="service-discount-saved">{{ $t('serviceSelect.save') }} {{currency.symbol}}{{ price(service.code).saved }}</span>
                      </div>
                      <div class="service-discount-info" v-if="leg === 'leg1' && !_isRoundtrip && !rsvpData.isAsap && (!_selectedService || (_selectedService && !rsvpData.pickupDate)) && price(service.code).rtPrice">
                        <div class="rt-dc-small">
                          <img src="../../assets/img/roundtrip-banner-small.png" />
                          <span>{{ price(service.code).rtPrice }}</span>
                        </div>
                      </div>

                      <div class="service-discount-timer" v-if="price(service.code).saved > 0">
                        <div>{{ $t('serviceSelect.discount') }}</div>
                        <span class="timer">{{ discountTimeLeft }}</span>
                      </div>

                      <div class="eta margin-t-s">
                        <div>
                          <span class="minutes-away" v-if="eta(service.code).minutesAway !== 999 && !sharedNotAvaialble(leg, service.code) && showEta">{{ eta(service.code).minutesAway }} minute(s) away</span>
                          <span :class="['suggested-pickup-time', /*{'not-allowed':!suggestedPickupTime(service.code).isAllowed}*/]"
                            @click.stop
                            v-if="(rsvpData.isAirportPickup || rsvpData.isAirportDropoff) && !rsvpData.isAsap && suggestedPickupTime(service.code).val && !charter.enabled">
                            <div>Click here to Customize your schedule</div>
                            {{ $t('serviceSelect.pickupDate') }}
                            <a @click="customPickupTime(service.code)">
                              {{ suggestedPickupTime(service.code).val }}
                              <i class="fas fa-edit"></i>
                            </a>
                          </span>
                          <span class="dropoff-time" v-if="showBtt && !charter.enabled">
                            {{ $t('serviceSelect.dropoffTime') }}
                            {{ eta(service.code).dropoffTime }}</span>
                        </div>
                        <div v-if="eta(service.code).minutesAway !== 999  && !sharedNotAvaialble(leg, service.code)"></div>
                        <div v-else-if="!sharedNotAvaialble(leg, service.code) && showEta && !charter.enabled">
                          <span class="no-cars">{{ $t('serviceSelect.bookAdvance') }}</span>
                        </div>
                      </div>

                      <div class="mng margin-t-m" v-if="hasMngOnly(service.code)">
                        {{ $t('serviceSelect.mng') }}
                        {{ mngComplimentary[service.code].pickupFee === 0 ? '(' + $t('serviceSelect.complimentary')+  ')' : `${currency.symbol}${toFixed(mngComplimentary[service.code].pickupFee)}` }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="disabled-date medium-above" v-if="service.unavailableTime">Not available on the selected date</div>

                <div class="medium-above">
                  <div class="ribbon lowest" v-if="ribbon(service.code).lowest && ribbonShow.lowest">
                    <img src="../../assets/img/lowest.png" />
                    <span>{{ $t('serviceSelect.bestValue') }}</span>
                  </div>

                  <div class="ribbon fastest" v-if="ribbon(service.code).fastest && ribbonShow.fastest">
                    <img src="../../assets/img/fastest.png" />
                    <span>{{ $t('serviceSelect.fastest') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="quoteLegLoading[leg]" class="service-loading">
      <i class="fas fa-spinner fa-spin fa-fw fa-2x"></i>
    </div>
    <div v-if="!Object.keys(services).length && !quoteLegLoading[leg]" class="no-service">{{ $t('searchForm.sorryService') }}</div>

    <shared-alloted-time-modal :leg="leg" :service="serviceLabel(nextAvailableService)"
      :code="serviceCode" ref="sharedModal"></shared-alloted-time-modal>
    <more-images></more-images>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment-timezone'
import SharedAllotedTimeModal from './SharedAllotedTimeModal'
import MoreImages from './MoreImages'
import featureToggle from '@/modules/api/featureToggle'
import { isValidNumber } from 'libphonenumber-js'
import ApiPickupType from '@/modules/api/pickup-type'
// import ApiQuote from '@/modules/api/quote'
import xcurrency from '@/modules/api/currency'
import serviceSession from '@/modules/api/service-session'

export default {
  name: 'services',
  components: { SharedAllotedTimeModal, MoreImages },
  props: ['leg'],
  data () {
    return {
      discountTimer: '',
      discountTimeLeft: '',
      disableAllService: false,
      selectedService: '',
      showDesc: {
        shared: false,
        opoli: false,
        black: false,
        suv: false,
        shuttle: false
      },
      currentPrice: {
        shared: 999,
        opoli: 999,
        black: 999,
        suv: 999,
        shuttle: 999
      },
      showSharedAllotedTimeModal: {
        leg1: false,
        leg2: false
      },
      serviceCode: '',
      pickupTypeDelay: '',
      offsets: {}
    }
  },
  computed: {
    currentBrand () { return this.$store.state.brandCode },
    rsvpData () { return this.$store.state.reservation[this.leg] },
    quoteLoading () { return this.$store.state.reservation.quotationloading },
    services () {
      let compiledService = []
      let disabledService = []
      let _services = this.rsvpData.services
      let brandCode = this.$store.state.brandCode
      // let servicesInfo = this.$store.state.reservation.servicesInfo[brandCode]

      let serviceOrder = _services
      let categories = {}
      for (let service in serviceOrder) {
        let ribbonLabel = ''
        if (brandCode === 'pts' && (service === 'shared')) { // || service === 'suv'
          ribbonLabel = {
            class: service === 'shared' ? 'new-improved' : 'new',
            value: service === 'shared' ? 'New and Improved!' : 'New!'
          }
        }
        // let imgServiceCode = _services[service].code === 'shuttle' ? 'private' : _services[service].code

        let upDownstairs = ''
        if (this.rsvpData.pickup.geofenceId === CONFIG.laxGeofenceId && this.rsvpData.pickup.geofenceType === 'airport') {
          upDownstairs = ['black', 'suv', 'shuttle'].indexOf(service) > -1 ? this.$t('serviceSelect.downstairs') : this.$t('serviceSelect.upstairs')
        }
        let paxLabel = ''
        let luggagelabel = ''
        let img = ''
        let excerpt = ''
        let description = ''
        let advantage = ''
        let stops = ''
        paxLabel = _services[service].maxPassengers + ' max'
        luggagelabel = _services[service].maxLuggage + ' max'
        img = _services[service].img
        excerpt = _services[service].excerpt
        description = _services[service].description
        if (_services[service].advantage) {
          advantage = `<b>[${this.$t('serviceSelect.advantage')}]</b>  ${_services[service].advantage}`
        }
        if (_services[service].stops) {
          stops = `<b>[${this.$t('serviceSelect.stops')}]</b>  ${_services[service].stops}`
        }
        if ((this.rsvpData.pickup.geofenceId === CONFIG.laxGeofenceId || CONFIG.showArrivalInstruction.indexOf(this.rsvpData.pickup.geofenceId) > -1) &&
          this.rsvpData.pickup.geofenceType === 'airport'
        ) {
          let pickupLabel = this.$store.state.instructions
          upDownstairs = _services[service].licenseType === 'tnc' ? pickupLabel.tnc.pickupLabel : pickupLabel.tcp.pickupLabel
        }
        if (!categories[_services[service].category]) {
          categories[_services[service].category] = {
            disabled: [],
            enabled: []
          }
        }

        let serviceBrand = 'op'
        if (['Executive Sedan', 'Executive SUV', 'Luxury Sedan', 'Luxury SUV', 'Luxury Limo'].indexOf(_services[service].brandedName) > -1 ||
          _services[service].brandedName === 'Limo'
        ) {
          serviceBrand = 'gs'
        }
        if (_services[service].brandedName.indexOf('Private Van') > -1) {
          serviceBrand = 'pts'
          if (brandCode === 's2l') serviceBrand = 'op'
        }
        if (_services[service].status === 'allowed') {
          let unavailableTime = _services[service].unavailableTime
          let leg1 = this.$store.state.reservation.leg1
          if (!this.quoteLoading && (
            !leg1.isAsap && (
              (!leg1.flightDate && (leg1.isAirportPickup || leg1.isAirportDropoff)) ||
              (!leg1.isAirportPickup && !!leg1.isAirportDropoff && !leg1.pickupDate))
            )
          ) {
            unavailableTime = false
          }
          let serviceData = {
            id: _services[service].id,
            code: _services[service].code,
            maxPaxLabel: paxLabel,
            maxLuggageLabel: luggagelabel,
            label: _services[service].brandedName,
            excerpt: excerpt,
            desc: description,
            advantage: advantage,
            stops: stops,
            img: img,
            brand: 'https://prod-opoli-app.s3-us-west-2.amazonaws.com/web/' + serviceBrand + '_logo.png',
            ribbonLabel: ribbonLabel,
            upDownstairs: upDownstairs,
            moreImgs: _services[service].moreImgs,
            currentPrice: _services[service].maxPassengers >= this.rsvpData.passenger ? _services[service].prices[this.rsvpData.passenger - 1].price : 0,
            unavailableTime: unavailableTime
          }
          if (this.leg === 'leg2') {
            let priceType = this.isLyftBooking ? 'prices' : 'roundtrip'
            serviceData.currentPrice = _services[service].maxPassengers >= this.rsvpData.passenger ? _services[service][priceType][this.rsvpData.passenger - 1].price : 0
          }
          if (this.serviceDisable(service)) {
            disabledService.push(serviceData)
          } else {
            compiledService.push(serviceData)
            categories[_services[service].category].enabled.push(serviceData)
          }
        }
      }
      for (let category in categories) {
        if (categories[category].enabled.length) {
          categories[category].enabled.sort((a, b) => a.currentPrice - b.currentPrice)
        }
        if (!categories[category].enabled.length && !categories[category].disabled.length) {
          delete categories[category]
        }
      }
      if (disabledService.length) {
        categories['zznot_applicable'] = {
          enabled: [],
          disabled: disabledService
        }
      }

      let execSUV = ''
      for (let category in categories) {
        categories[category] = categories[category].enabled.concat(categories[category].disabled)
        if (CONFIG.featureToggle.oldServiceUI.indexOf(this.$store.state.brandId) > -1) {
          categories[category].sort((a, b) => a.currentPrice - b.currentPrice)
        }
      }
      if (execSUV) {
        if (!categories['']) categories[''] = []
        categories[''].push(execSUV)
        categories = Object.assign({'': null}, categories) // rearrange order
      }

      return categories
    },
    loading () { return this.$store.state.reservation.serviceLoading },
    maxPax () {
      let servicePrices = this.rsvpData.services
      let pax = {}
      for (let service in servicePrices) {
        let code = servicePrices[service].code
        if (code) {
          pax[code] = false
          if (this.rsvpData.passenger > servicePrices[service].maxPassengers) {
            pax[code] = true
            if (this.selectedService === code) {
              this.selectedService = ''
              this.$store.commit('reservation/setSelectedService', {
                leg: this.leg,
                value: ''
              })
              this.updatePickupType()
            }
          }
        }
      }

      this.$forceUpdate()
      return pax
    },
    maxLuggage () {
      let servicePrices = this.rsvpData.services
      let luggage = {}
      for (let service in servicePrices) {
        let code = servicePrices[service].code
        if (code) {
          luggage[code] = false
          if (this.rsvpData.luggage > servicePrices[service].maxLuggage) {
            luggage[code] = true
            if (this.selectedService === code) {
              this.selectedService = ''
              this.$store.commit('reservation/setSelectedService', {
                leg: this.leg,
                value: ''
              })
              this.updatePickupType()
            }
          }
        }
      }

      return luggage
    },
    _selectedService () { return this.rsvpData.selectedService },
    ribbonShow () {
      let rsvp = this.$store.state.reservation.leg1
      return {
        lowest: !this.loading,
        fastest: this.leg === 'leg1' && !this.loading &&
        (rsvp.isAsap || rsvp.pickupDate === '')
      }
    },
    _serviceLoading () { return this.$store.state.reservation.serviceLoading },
    nextAvailableService () {
      if (this._serviceLoading || !this.$store.state.reservation[this.leg].services) { return '' }

      let services = this.$store.state.reservation[this.leg].services
      for (let i in services) {
        if (this.rsvpData.services[i] && !this.serviceDisable(i)) {
          this.serviceCode = this.rsvpData.services[i].code
          return this.rsvpData.services[i].code
        }
      }

      return ''
    },
    showEta () {
      let rsvp = this.$store.state.reservation.leg1
      return rsvp.isAsap || (rsvp.pickupDate === '' && rsvp.flightDate === '')
    },
    mngComplimentary () { return this.$store.state.reservation[this.leg].services },
    sharedAllowTime () {
      let rsvp = this.$store.state.reservation
      return {
        start: rsvp.sharedAllowedTime.start,
        end: rsvp.sharedAllowedTime.end
      }
    },
    _pickupDate () { return this.rsvpData.pickupDate },
    showBtt () {
      if (this.rsvpData.isAsap) { return true }
      if (this.rsvpData.isAirportPickup || this.rsvpData.isAirportDropoff) {
        return this.rsvpData.flightDate && this.rsvpData.airline && this.rsvpData.flightNo
      }
      return true
    },
    _pickupTimeOffsets () { return this.$settings.get('PickupTimeOffsets') },
    helpLink () {
      switch (this.$store.state.brandCode) {
        case 'pts': return '/help'
        case 'op': return '/faqs'
        default: return '/faq'
      }
    },
    _discountTimer () { return this.$store.state.reservation.discountTillInUnix },
    _passenger () { return this.rsvpData.passenger },
    _isRoundtrip () { return this.$store.state.reservation.isRoundtrip },
    extraStop () { return this.$store.state.reservation.extraStop[this.leg] },
    charter () { return this.$store.state.reservation.charter },
    useFullPrice () { return CONFIG.featureToggle.serviceFullPrice },
    currency () { return this.$store.state.other.currency },
    isAsap () { return this.rsvpData.isAsap },
    isLyftBooking () { return this.isAsap || this.$store.state.reservation.lyft[this.leg === 'leg1' ? 'enabled' : 'enabledLeg2'] },
    quoteLegLoading () { return this.$store.state.reservation.quoteLegLoading }
  },
  methods: {
    toFixed (x) { return parseFloat(x).toFixed(2) },
    price (service) {
      if (!service) return
      let serviceData = this.rsvpData.services[service]
      let leg1 = this.$store.state.reservation.leg1
      if (this.rsvpData.passenger > serviceData.maxPassengers ||
        this.rsvpData.luggage > serviceData.maxLuggage ||
        serviceData.status !== 'allowed' || !this.sharedAllowedTime(service) ||
        (this.extraStop.length && serviceData.isShared) ||
        (serviceData.unavailableTime && !this.quoteLoading &&
          (leg1.isAsap || (leg1.flightDate && (leg1.isAirportPickup || leg1.isAirportDropoff)) ||
          (!leg1.isAirportPickup && !!leg1.isAirportDropoff && leg1.pickupDate))
        )
      ) {
        this.currentPrice[service] = 999
        return {
          price: this.$t('serviceSelect.NA'),
          original: 0,
          saved: 0
        }
      }

      let prices = serviceData.prices[this.rsvpData.passenger - 1]
      let rsvp = this.$store.state.reservation
      if (!this.isLyftBooking && rsvp.isRoundtrip &&
        ((this.leg === 'leg2' && rsvp.leg1.selectedService === service) ||
        (this.leg === 'leg1' && rsvp.leg2.selectedService === service))
      ) {
        prices = serviceData.roundtrip[this.rsvpData.passenger - 1]
      }

      this.currentPrice[service] = parseFloat(prices.price)
      if (this.useFullPrice) {
        let fees = serviceData.airportFee || 0
        fees += serviceData.gasFee || 0
        fees += serviceData.travelInsurance || 0

        let fullPriceData = {
          price: `$${this.toFixed(this.priceNonNegative(prices.price + fees))}`,
          original: `$${this.toFixed(this.priceNonNegative(prices.original + fees))}`,
          saved: this.toFixed(this.priceNonNegative(prices.original - prices.price)),
          rtPrice: !this.charter.enabled && this.leg === 'leg1' && serviceData.roundtrip[this.rsvpData.passenger - 1].discount ? '$' + this.toFixed(this.priceNonNegative(serviceData.roundtrip[this.rsvpData.passenger - 1].discount * 2)) : ''
        }
        if (this.currency.code !== 'USD') {
          fullPriceData.price = this.applyCurrency(prices.price + fees)
          fullPriceData.original = this.applyCurrency(prices.original + fees)
          fullPriceData.saved = this.applyCurrency(prices.original - prices.price, false)
          if (!this.charter.enabled && this.leg === 'leg1' && serviceData.roundtrip[this.rsvpData.passenger - 1].discount) {
            fullPriceData.rtPrice = this.applyCurrency(serviceData.roundtrip[this.rsvpData.passenger - 1].discount * 2)
          }
        }
        return fullPriceData
      }

      let priceType = this.isLyftBooking || !this._isRoundtrip ? 'prices' : 'roundtrip'
      let priceData = {
        price: '$' + this.toFixed(this.priceNonNegative(prices.price)),
        original: '$' + this.toFixed(this.priceNonNegative(prices.original)),
        saved: this.toFixed(this.priceNonNegative(prices.original - prices.price)),
        rtPrice: !this.charter.enabled && this.leg === 'leg1' && serviceData[priceType][this.rsvpData.passenger - 1].discount ? '$' + this.toFixed(this.priceNonNegative(serviceData[priceType][this.rsvpData.passenger - 1].discount * 2)) : ''
      }
      if (this.currency.code !== 'USD') {
        priceData.price = this.applyCurrency(prices.price)
        priceData.original = this.applyCurrency(prices.original)
        priceData.saved = this.applyCurrency(prices.original - prices.price, false)
        if (!this.charter.enabled && this.leg === 'leg1' && serviceData[priceType][this.rsvpData.passenger - 1].discount) {
          priceData.rtPrice = this.applyCurrency(serviceData[priceType][this.rsvpData.passenger - 1].discount * 2)
        }
      }
      return priceData
    },
    priceNonNegative (x) {
      x = parseFloat(x)
      return x < 0 ? 0 : x
    },
    serviceDisable (service) {
      let _services = this.rsvpData.services
      if (this.charter.enabled) {
        if (!this.chkCharterMinDuration(service)) return true
      }
      let leg1 = this.$store.state.reservation.leg1
      return this.maxPax[service] || this.maxLuggage[service] ||
        (this.availabilityInfo(service).enabled && !this.availabilityInfo(service).eligible) ||
        !this.sharedAllowedTime(service) || this.disableAllService ||
        this.rsvpData.services[service].status === 'restricted' ||
        // (!this.suggestedPickupTime(service).isAllowed && this.suggestedPickupTime(service).val && !this.rsvpData.isAsap) ||
        (this.extraStop.length && _services[service].isShared) ||
        (_services[service].unavailableTime && !this.quoteLoading && ((leg1.flightDate && (leg1.isAirportPickup || leg1.isAirportDropoff)) || leg1.pickupDate || leg1.isAsap))
    },
    chkCharterMinDuration (service) {
      if (!this.charter.enabled) return true
      let selectedService = service.replace('a', '')
      let minDuration = this.charter.minDuration
      let minDurationServiceId = this.charter.minDurationServiceId
      let startDate = moment(this.charter.startDate, 'MM/DD/YYYY hh:mmA')
      let endDate = moment(this.charter.endDate, 'MM/DD/YYYY hh:mmA')
      if (
        !this.charter.startDate || !this.charter.endDate ||
        (minDurationServiceId.indexOf(selectedService) > -1 && endDate.diff(startDate, 'minutes') < minDuration)
      ) return false // Time duration within charter-min-duration settings
      return true // NO ISSUE
    },
    availabilityInfo (service) {
      let rsvpLeg = this.$store.state.reservation[this.leg]
      let serviceInfo = rsvpLeg.services[service]
      let enabled = false
      let eligible = 0
      let suggestedLabel = this.$t('serviceSelect.NA')
      let suggestedTime = ''
      if (serviceInfo.availabilityInfo) {
        enabled = serviceInfo.availabilityInfo.enabled
        eligible = serviceInfo.availabilityInfo.eligible

        if (rsvpLeg.isAsap) {
          if (serviceInfo.availabilityInfo.suggest.after) {
            suggestedLabel = this.$t('serviceSelect.availableFrom')
            suggestedTime = moment(serviceInfo.availabilityInfo.suggest.after, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA')
          }
        } else {
          if (serviceInfo.availabilityInfo.suggest.after) {
            suggestedLabel = this.$t('serviceSelect.availableFrom')
            suggestedTime = moment(serviceInfo.availabilityInfo.suggest.after, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA')
          } else if (serviceInfo.availabilityInfo.suggest.before) {
            suggestedLabel = this.$t('serviceSelect.availableUntil')
            suggestedTime = moment(serviceInfo.availabilityInfo.suggest.before, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA')
          }
        }
      }

      if (enabled && eligible === 0 && service === rsvpLeg.selectedService) {
        this.$store.commit('reservation/setSelectedService', {
          leg: this.leg,
          value: ''
        })
      }

      return {
        enabled: enabled,
        eligible: eligible,
        suggestedLabel: suggestedLabel,
        suggestedTime: suggestedTime
      }
    },
    sharedAllowedTime (service) {
      let self = this
      let sharedAllow = true
      let rsvp = this.$store.state.reservation
      if (this.rsvpData.isAirportPickup) {
        if (!this.rsvpData.isAsap && !this.rsvpData.flightDate && !this.rsvpData.airline && !this.rsvpData.flightNo && !this.$store.state.reservation.lyft.enabled) { return true }

        let selectedTime = moment()
        if (this.rsvpData.flightDate && this.rsvpData.airline && this.rsvpData.flightNo) {
          selectedTime = moment(this.suggestedPickupTime(service).val, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
        } else if (this.rsvpData.pickupDate) {
          selectedTime = moment(this.rsvpData.pickupDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
        } else if (this.leg === 'leg2') {
          return
        }
        selectedTime = moment(selectedTime.format('hh:mmA'), 'hh:mmA')

        let allowTimeStart = moment(rsvp.sharedAllowedTime.start, 'hh:mmA')
        let allowTimeEnd = moment(rsvp.sharedAllowedTime.end, 'hh:mmA')
        this.showSharedAllotedTimeModal[this.leg] = false

        if (rsvp[this.leg].services[service] && rsvp[this.leg].services[service].isShared &&
          parseInt(selectedTime.format('X')) >= parseInt(allowTimeStart.format('X')) &&
          parseInt(selectedTime.format('X')) <= parseInt(allowTimeEnd.format('X'))
        ) {
          this.$store.commit('reservation/setSharedNotAvaialble', {
            leg: this.leg,
            value: false
          })
        }
        if (rsvp[this.leg].services[service] && rsvp[this.leg].services[service].isShared &&
          (parseInt(selectedTime.format('X')) < parseInt(allowTimeStart.format('X')) ||
          parseInt(selectedTime.format('X')) > parseInt(allowTimeEnd.format('X'))) &&
          rsvp[this.leg].flightNo
        ) {
          this.$store.commit('reservation/setSharedNotAvaialble', {
            leg: this.leg,
            value: true
          })
          sharedAllow = false
          if (this.selectedService === service) {
            this.$store.commit('reservation/setSelectedService', {
              leg: this.leg,
              value: ''
            })
            this.updatePickupType()

            this.showSharedAllotedTimeModal[this.leg] = true
            setTimeout(function () {
              if (self.$refs.sharedModal.showModal()) { self.$refs.sharedModal.showModal() }
            }, 500)
          }
        }
      }

      return sharedAllow
    },
    discountCountdown () {
      let discountTill = ''

      if (this.$store.state.reservation.discountTill) {
        discountTill = moment(this.$store.state.reservation.discountTill + ' 23:59', 'MM-DD-YYYY HH:mm').fromNow(moment())
        if (discountTill.indexOf('days') > -1 || discountTill.indexOf('month') > -1 ||
          discountTill.indexOf('year') > -1
        ) {
          // discountTill = discountTill.substring(0, discountTill.length - 5)
          // this.discountTimeLeft = discountTill + ' day(s) left'
          this.discountTimeLeft = moment.unix(this.$store.state.reservation.discountTillInUnix).diff(moment(), 'days') + ' ' + this.$t('serviceSelect.daysLeft')
          if (this.discountTimer) { clearInterval(this.discountTimer) }
        } else {
          let eventTime = moment(this.$store.state.reservation.discountTill, 'MM-DD-YYYY').add(1, 'days').format('X');
          let currentTime = moment().format('X');
          let diffTime = eventTime - currentTime;
          let duration = moment.duration(diffTime * 1000, 'milliseconds');

          this.discountTimeLeft = ('0' + duration.hours()).slice(-2) + ':'
          this.discountTimeLeft += ('0' + duration.minutes()).slice(-2) + ':'
          this.discountTimeLeft += ('0' + duration.seconds()).slice(-2) + ' ' + this.$t('serviceSelect.timeLeft')

          if (duration.hours() === 0 && duration.minutes() === 0 &&
            duration.seconds() === 0
          ) {
            clearInterval(this.discountTimer)
          }
        }
      } else {
        clearInterval(this.discountTimer)
      }
    },
    selectService (code) {
      let self = this
      if (self.serviceDisable(code)) { return }
      self.selectedService = code
      self.$store.commit('reservation/setSelectedService', {
        leg: self.leg,
        value: code
      })
      self.$store.commit('reservation/setCharterData', {selectedService: code})
      if (self.leg === 'leg1') {
        self.$store.commit('reservation/setSelectedService', {
          leg: 'leg2',
          value: code
        })
      }

      self.showDesc[code] = true
      self.$nextTick().then(() => {
        self.$forceUpdate()
      })

      if (!self.rsvpData.pickupDate) {
        self.$store.commit('reservation/setPickupDate', { leg: self.leg, value: self.suggestedPickupTime(code).val })
      }

      if (/*CONFIG.Env == 'production' &&*/ window.gtag) { // eslint-disable-line
        let service = self.rsvpData.services[code]
        let eventName = self.leg === 'leg2' ? `Service_LEG2_${service.brandedName}` : `Service_${service.brandedName}`
        gtag('event', eventName) // eslint-disable-line
      }
      setTimeout(() => {
        let elm = document.querySelector("#bookingForm")
        if (elm) elm.scrollTo({top: document.body.scrollHeight, behavior: 'smooth'})
      }, 100);

      self.updatePickupType()
    },
    ribbon (service) {
      let self = this
      for (let code in self.currentPrice) {
        if (!self.rsvpData.services[code]) {
          delete self.currentPrice[code]
        }
      }
      if (!Object.keys(self.currentPrice).length) {
        return { lowest: false, fastest: false }
      }
      let tempCurrentPrice = Object.assign({}, self.currentPrice)
      let services = this.$store.state.reservation[this.leg].services
      for (let ser in tempCurrentPrice) {
        if ((!this.suggestedPickupTime(ser).isAllowed && this.suggestedPickupTime(ser).val) ||
          (services[ser].availabilityInfo && services[ser].availabilityInfo.eligible === 0) ||
          (self.extraStop.length && services[ser].isShared)
        ) {
          tempCurrentPrice[ser] = 999
        }
      }
      let lowest = Object.keys(tempCurrentPrice).reduce((a, b) => tempCurrentPrice[a] <= tempCurrentPrice[b] ? a : b)

      let serviceEta = Object.assign({}, self.$store.state.reservation.serviceEta)
      for (let code in serviceEta) {
        if (!self.rsvpData.services[code] && serviceEta[code]) {
          delete serviceEta[code]
        }
      }
      for (let ser in serviceEta) {
        if ((!this.suggestedPickupTime(ser).isAllowed && this.suggestedPickupTime(ser).val) ||
          (self.extraStop.length && services[ser].isShared)
        ) {
          serviceEta[ser] = 999
        }
      }
      let fastest = ''
      if (Object.keys(serviceEta).length) {
        fastest = Object.keys(serviceEta).reduce((a, b) => serviceEta[a] <= serviceEta[b] ? a : b)
      }

      // temporary ------------------
      let executiveSuvIDs = [12, 15, 24, 32] // PROD
      // let executiveSuvIDs = [178, 95, 81, 110] // STAGING
      if (Object.values(services).find(x => executiveSuvIDs.indexOf(x.id) > -1)) {
        return {
          lowest: services[service] && executiveSuvIDs.indexOf(services[service].id) > -1,
          fastest: fastest === service && serviceEta[lowest] !== 999
        }
      }
      // ----------------------------

      return {
        lowest: lowest === service && tempCurrentPrice[lowest] !== 999,
        fastest: fastest === service && serviceEta[lowest] !== 999
      }
    },
    eta (service) {
      let rsvp = this.$store.state.reservation
      let minutesAway = rsvp.serviceEta[service]
      let eta = Math.ceil(rsvp[this.leg].eta / 60)
      let btt = eta * 1.15
      if (rsvp[this.leg].services[service] && rsvp[this.leg].services[service].isShared) {
        btt = eta * (1 + (this.$settings.get('OfferLimitThreshold') / 100))
      }

      let dropoffTime = moment().tz(rsvp[this.leg].timezone)
      if (rsvp[this.leg].flightDate && rsvp[this.leg].airline && rsvp[this.leg].flightNo && (rsvp[this.leg].isAirportPickup || rsvp[this.leg].isAirportDropoff)) {
        dropoffTime = moment(this.suggestedPickupTime(service).val, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
      } else if (rsvp[this.leg].pickupDate && !rsvp[this.leg].isAsap) {
        dropoffTime = moment(rsvp[this.leg].pickupDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
      }
      if (rsvp[this.leg].isAsap) {
        dropoffTime = dropoffTime.add(minutesAway, 'minutes')
      }
      dropoffTime = dropoffTime.add(btt, 'minutes')
      return {
        minutesAway: parseInt(minutesAway || 999),
        dropoffTime: dropoffTime.format(featureToggle.timeFormat(this, false))
      }
    },
    showService (service) {
      return this.rsvpData.selectedService === '' || this.rsvpData.selectedService === service
    },
    showServiceViaCategory (category) {
      if (this.isLyftBooking) return true
      return this.rsvpData.selectedService === '' || (this.rsvpData.services[this.rsvpData.selectedService] && this.rsvpData.services[this.rsvpData.selectedService].category === category)
    },
    hasMngOnly (service) {
      let services = this.$store.state.reservation[this.leg].services[service]
      return !services.curbside && services.meetAndGreet
    },
    transitionComplete (el) { el.style.maxHeight = '900px' },
    willLeave (el) { el.style.maxHeight = '' },
    updatePickupType () {
      let self = this
      let user = self.$store.state.user
      let notInternational = true
      if (user.phone.number) {
        let userPhone = '+' + user.phone.code + user.phone.number
        notInternational = isValidNumber(userPhone, 'US') || isValidNumber(userPhone, 'CA')
      }

      if (self.pickupTypeDelay) { clearTimeout(self.pickupTypeDelay) }
      self.pickupTypeDelay = setTimeout(function () {
        ApiPickupType.update(self, {isUS: notInternational}, function () {})
      }, 300)
    },
    sharedNotAvaialble (leg, service) {
      if (!this.$store.state.reservation[leg].services[service].isShared) return false
      return this.$store.state.reservation.sharedNotAvaialble[leg]
    },
    showSuggestedService (leg, code) {
      if (!this.$store.state.reservation[leg].services[code].isShared) return false

      return (this.sharedNotAvaialble(leg, code) || this.maxPax[code] || this.maxLuggage[code]) &&
        this.nextAvailableService !== ''
    },
    serviceLabel (code) {
      if (!code) { return '' }
      return this.rsvpData.services[code].brandedName || ''
    },
    suggestedPickupTime (service, bypass = false) {
      let rsvp = this.$store.state.reservation
      if (!rsvp.suggestedTime[this.leg].time) { return '' }

      let timezone = rsvp[this.leg].timezone
      let date = moment(rsvp.suggestedTime[this.leg].time, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
      let _date = moment.tz(rsvp.suggestedTime[this.leg].time, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false), timezone)
      if (rsvp[this.leg].isAirportPickup) {
        let delay = rsvp.suggestedTime[this.leg].isDomestic ? 'ArrivalDomesticDelay' : 'ArrivalInternationalDelay'
        date.add(this.$settings.get(delay), 'minutes')
        _date.add(this.$settings.get(delay), 'minutes')
      } else if (rsvp[this.leg].isAirportDropoff) {
        let delay = rsvp.suggestedTime[this.leg].isDomestic ? 'DepartureDomesticBuffer' : 'DepartureInternationalBuffer'
        let eta = Math.ceil(rsvp[this.leg].eta / 60)
        let btt = Math.ceil(eta * 1.15)
        if (this.$store.state.reservation[this.leg].services[service].isShared) {
          btt = Math.ceil(eta * (1 + (this.$settings.get('OfferLimitThreshold') / 100)))
          btt = (btt - (btt % 5)) + 5
        }
        let timeDelay = Math.ceil(parseFloat(this.$settings.get(delay)))
        date.subtract(timeDelay + btt, 'minutes')
        date.subtract(parseInt(date.format('mm')) % 5, 'minutes')
        _date.subtract(timeDelay + btt, 'minutes')
        _date.subtract(parseInt(date.format('mm')) % 5, 'minutes')
      }

      if (rsvp.customPickupTime[this.leg] && !bypass) {
        date = moment(rsvp[this.leg].pickupDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
        _date = moment.tz(rsvp[this.leg].pickupDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false), timezone)
      } else {
        if (this.offsets['a' + date.format('e')] && rsvp[this.leg].isAirportDropoff) {
          let found = false
          this.offsets['a' + date.format('e')].forEach(function (data, index) {
            let time = moment(date.format('HHmm'), 'HHmm')
            let start = moment(data.start, 'HHmm')
            let end = moment(data.end, 'HHmm')
            if (time.isBetween(start, end) && !found) {
              found = true
              if (data.value.indexOf('-') > -1) {
                date.subtract(data.value.substring(1, data.value.length), 'minutes')
                _date.subtract(data.value.substring(1, data.value.length), 'minutes')
              } else {
                date.add(data.value, 'minutes')
                _date.add(data.value, 'minutes')
              }
            }
          })
        }
      }
      return {
        val: date.format('MM/DD/YYYY ' + featureToggle.timeFormat(this, false)),
        isAllowed: !_date.isBefore(moment().tz(timezone).add(this.$settings.get('WebTimeBuffer'), 'minutes'))
      }
    },
    customPickupTime (code) {
      let self = this
      if (self.serviceDisable(code)) { return }

      self.$store.commit('reservation/setActiveLeg', self.leg)
      self.$store.commit('serviceSelection/setSuggestedTime', this.suggestedPickupTime(code, true).val)
      self.$store.commit('serviceSelection/setForPickupDate', true)
      self.$store.commit('serviceSelection/setCustomPickupDateDefault', this.suggestedPickupTime(code).val)
      self.$store.commit('serviceSelection/showDateTimePicker')
    },
    setPickupTimeOffsets () {
      let self = this
      let PickupTimeOffsets = this.$settings.get('PickupTimeOffsets')
      if (PickupTimeOffsets) {
        let split = PickupTimeOffsets.split(',')
        split.forEach(function (val, index) {
          if (!self.offsets['a' + val.substring(0, 1)]) {
            self.offsets['a' + val.substring(0, 1)] = []
          }
          self.offsets['a' + val.substring(0, 1)].push({
            start: val.substring(1, 5),
            end: val.substring(5, 9),
            value: val.substring(9, val.length)
          })
        })
      }
    },
    toggleDescription (code) {
      let self = this
      self.showDesc[code] = !this.showDesc[code]
      self.$nextTick().then(() => {
        self.$forceUpdate()
      })
    },
    setDefaultTip () {
      let serviceData = this.rsvpData.services[this.selectedService]
      let rsvpStore = this.$store.state.reservation
      let isRoundtrip = rsvpStore.isRoundtrip

      if (!this.selectedService || !serviceData ||
        (this.leg === 'leg2' && !isRoundtrip) || this.$store.state.isManualTip
      ) {
        return
      }

      let leg1 = rsvpStore.leg1
      let leg2 = rsvpStore.leg2
      if (isRoundtrip && leg1.selectedService && leg2.selectedService && leg2.services[leg2.selectedService]) {
        let paxLeg1 = leg1.passenger || 1
        let paxLeg2 = leg2.passenger || 1
        let pricesLeg1 = leg1.services[leg1.selectedService].prices[paxLeg1 - 1]
        let pricesLeg2 = leg2.services[leg2.selectedService].prices[paxLeg2 - 1]

        let tipLeg1 = parseFloat((pricesLeg1.price * (leg1.services[leg1.selectedService].defaultTip / 100)).toFixed(2))
        let tipLeg2 = parseFloat((pricesLeg2.price * (leg2.services[leg2.selectedService].defaultTip / 100)).toFixed(2))
        this.$store.commit('setTipLeg', {
          leg: 'leg1',
          value: parseFloat(tipLeg1)
        })
        this.$store.commit('setTipLeg', {
          leg: 'leg2',
          value: parseFloat(tipLeg2)
        })
        let totalTipAmount = parseFloat(this.toFixed(tipLeg1 + tipLeg2))
        this.$store.commit('setTipAmount', totalTipAmount)
        this.$store.commit('setTipIntl', parseFloat((totalTipAmount * this.currency.value).toFixed(2)))
      } else {
        let pax = this.rsvpData.passenger || 1
        let prices = serviceData.prices[pax - 1]
        let tip = serviceData.defaultTip / 100
        this.$store.commit('setTipLeg', {
          leg: this.leg,
          value: parseFloat(prices.price * tip)
        })
        let totalTipAmount = parseFloat(this.toFixed(prices.price * tip))
        this.$store.commit('setTipAmount', totalTipAmount)
        this.$store.commit('setTipIntl', parseFloat((totalTipAmount * this.currency.value).toFixed(2)))
      }
    },
    showMoreImgs (x) {
      this.$store.commit('moreImages/setImagesData', {
        show: true,
        service: x.label,
        imgs: x.moreImgs
      })
    },
    rechkServiceBuffer () {
      if (!this._selectedService) return
      let service = this.rsvpData.services[this._selectedService]
      let nowPlusBuffer = moment().add(service.bufferTime, 'minutes')
      let pickupDate = moment(this._pickupDate, 'MM/DD/YYYY hh:mmA')
      if (pickupDate.isBefore(nowPlusBuffer)) {
        console.log('#FIX.deselect', this.leg)
        this.selectedService = ''
        this.$store.commit('reservation/setSelectedService', {
          leg: this.leg,
          value: ''
        })
        this.$emit('rerender')
      }
    },
    applyCurrency (x, useSymbol = true) {
      x = parseFloat(x)
      x = x * this.currency.value
      if (!useSymbol) {
        return parseFloat(x.toFixed(2))
      }
      if (x < 0) x = 0
      return xcurrency.format({
        code: this.currency.code,
        val: x.toFixed(2)
      }, useSymbol)
    },
    updateServiceSession () {
      let token = this.$store.state.user.token
      let rsvp = this.$store.state.reservation
      let leg1 = rsvp.leg1
      let leg2 = rsvp.leg2
      if (!token || !leg1.selectedService || this.charter.enabled || leg1.isAsap) return

      // _isRoundtrip
      let priceType = !this._isRoundtrip ? 'prices' : 'roundtrip'
      if (this.lyft.enabled || this.lyft.enabledLeg2) priceType = 'prices'
      let legs = [
        {
          amount: leg1.services[leg1.selectedService][priceType][leg1.passenger - 1].price,
          serviceTypeId: leg1.services[leg1.selectedService].id,
          airportFee: leg1.services[leg1.selectedService].airportFee || 0,
          gasFee: leg1.services[leg1.selectedService].gasFee || 0,
          travelInsurance: leg1.services[leg1.selectedService].travelInsurance || 0
        },
        null
      ]
      if (this._isRoundtrip && leg2.selectedService) {
        legs[1] = {
          amount: leg2.services[leg2.selectedService][priceType][leg2.passenger - 1].price,
          serviceTypeId: leg2.services[leg2.selectedService].id,
          airportFee: leg2.services[leg2.selectedService].airportFee || 0,
          gasFee: leg2.services[leg2.selectedService].gasFee || 0,
          travelInsurance: leg2.services[leg2.selectedService].travelInsurance || 0
        }
      }

      serviceSession.sendSession(this, {
        token: token,
        brandId: this.$store.state.brandId,
        deviceType: 'ww',
        legs: legs
      }, res => {
        // console.log('cb', res)
      }, '/')
    }
  },
  watch: {
    _selectedService: function (value) {
      this.selectedService = value
      if (!value) {
        for (let service in this.showDesc) {
          this.showDesc[service] = false
        }
      }
      this.updateServiceSession()
      this.setDefaultTip()
    },
    _serviceLoading: function (value) {
      if (!value && this.showSharedAllotedTimeModal[this.leg]) {
        this.showSharedAllotedTimeModal[this.leg] = false
        if (this.$refs.sharedModal.showModal()) { this.$refs.sharedModal.showModal() }
      }
    },
    _pickupDate: function (value) {
      if (value) {
        let self = this
        let rsvp = self.$store.state.reservation[self.leg]
        let pickupDate = rsvp.pickupDate || rsvp.flightDate
        pickupDate = pickupDate || moment().format('MM/DD/YYYY')
        pickupDate = moment(pickupDate, 'MM/DD/YYYY').format('YYYY-MM-DD')
        let quoteData = {
          date: pickupDate,
          leg: self.leg,
          brandId: self.$store.state.brandId,
          pickup: { lat: rsvp.pickup.lat, lng: rsvp.pickup.lng },
          dropoff: { lat: rsvp.dropoff.lat, lng: rsvp.dropoff.lng },
          asap: this.rsvpData.isAsap
        }

        quoteData.pickup = rsvp.pickup
        quoteData.dropoff = rsvp.dropoff

        self.$store.commit('reservation/setServiceLoading', true)
        setTimeout(function () {
          quoteData = {
            brandId: self.$store.state.brandId,
            leg: self.leg,
            pickupDate: pickupDate,
            pickup: {
              lat: rsvp.pickup.lat,
              lng: rsvp.pickup.lng
            },
            dropoff: {
              lat: rsvp.dropoff.lat,
              lng: rsvp.dropoff.lng
            },
            order: 'priority'
          }
          self.extraStop.forEach((stop, index) => {
            if (!quoteData.extraStops) {
              quoteData.extraStops = []
            }
            quoteData.extraStops.push({
              lat: stop.location.lat,
              lng: stop.location.lng
            })
          })
          // ApiQuote.getQuote2(self, quoteData, (res) => {
          //   self.$store.commit('reservation/setServiceLoading', false)
          //   if (!res.error) {
          //     self.$forceUpdate()
          //     let user = self.$store.state.user
          //     let notInternational = true
          //     if (user.phone.number) {
          //       let userPhone = '+' + user.phone.code + user.phone.number
          //       notInternational = isValidNumber(userPhone, 'US') || isValidNumber(userPhone, 'CA')
          //     }
          //     self.setDefaultTip()

          //     let serviceExist = false
          //     for (let service in res.services) {
          //       let serviceData = res.services[service]
          //       if (parseInt(self.rsvpData.selectedService.substr(1)) === serviceData.serviceType.id) {
          //         serviceExist = true
          //       }
          //     }
          //     if (res.lyft) {
          //       res.lyft.forEach(lyft => {
          //         if (self.rsvpData.selectedService === `a${lyft.ride_type}`) serviceExist = true
          //       })
          //     }
          //     if (!serviceExist) {
          //       self.$store.commit('reservation/setSelectedService', {
          //         leg: self.leg,
          //         value: ''
          //       })
          //       self.$store.commit('setCurrentIndex', 0)
          //       self.$store.commit('disablePreviousSteps', 3)
          //     }
          //     // self.rechkServiceBuffer()
          //     ApiPickupType.update(self, {isUS: notInternational}, function () {})
          //   }
          // })
        }, 100)
      }
    },
    _pickupTimeOffsets: function (value) {
      if (value) {
        this.setPickupTimeOffsets()
      }
    },
    _discountTimer: function (value) { this.discountCountdown() },
    _passenger: function (value) { this.setDefaultTip() },
    _isRoundtrip: function (value) { this.setDefaultTip() }
  },
  created: function () {
    if (this.discountTimer) { clearInterval(this.discountTimer) }
    this.discountTimer = setInterval(this.discountCountdown, 1000)
    this.selectedService = this.rsvpData.selectedService
  },
  mounted () {
    let self = this
    self.setPickupTimeOffsets()
    if (self._selectedService) {
      self.$nextTick().then(() => {
        self.showDesc[self._selectedService] = true
        self.$forceUpdate()
      })
    }

    self.$nextTick().then(function () {
      self.$forceUpdate()
    })
  }
}
</script>

<style lang="scss" scoped>
.services{
  padding: 10px 0;
  position: relative;
}
.service-loading{
  padding: 20px 10px;
  text-align: center;
}
.no-service{
  padding: 20px 10px;
  text-align: center;
  letter-spacing: .6px;
  font-size: 15px;
  font-style: italic;
  background: #f8f8f8;
  color: #aaa;
}

.catergory-box{
  padding: 15px;
  background: #f6f6f6;
  border-radius: 6px;
  margin-bottom: 10px;

  &:nth-child(even){
    background: #f6f6f6;
  }
}
.catergory-label{
  font-size: 27px;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  text-transform: uppercase;
}

.service-box{
  position: relative;
  overflow: hidden;
  max-height: 999px;
  padding: 10px 0;
}
.service {
  background-color: #d0d0d0;
  border: 2px solid #ccc;
  border-radius: 3px;
  width: 100%;
  display: block;
  margin-right: 11px;
  margin-bottom:0!important;
  text-align: center;
  padding: 0;
  cursor: pointer;
  transition: all .3s ease;

  &:hover:not(.disabled), &.active { border: 2px solid #923BBD; }
  &.disabled, &.disabled a{
    opacity: .65;
    cursor: default;
  }

  &.no-margin { margin-right: 0; }

  .service-img {
    display: table-cell;
    z-index: 2;
    transition: all .2s ease-in;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);

    img{
      max-width: 98%;
      max-height: 150px;
    }
  }

  .service-data-box{ background: #f6f6f6; }
  .service-data{
    width: 100%;
    background: #fff;
    // display: table-cell;
    text-align: left;
    padding: 15px;
    position: relative;
    z-index: 2;

    .ribbon{
      position: absolute;
      right: 170px;
      top: -10px;
      color: #fff;
      text-align: center;

      img{
        position: relative;
        z-index: 2;
        width: 80px;
      }
      span{
        position: absolute;
        z-index: 3;
        top: 0;
        width: 100%;
        left: 0;
        padding: 5px 15px 0;
        font-size: 13px;
        line-height: 130%;
      }
      &:before{
        content: '';
        border-style: solid;
        border-width: 9px 0 0 8px;
        position: absolute;
        z-index: 3;
        left: 100%;
        top: 0;
      }
      &.lowest{
        z-index: 5;
        &:before{ border-color: transparent transparent transparent #a54041; }
      }
      &.fastest{
        z-index: 4;
        span{
          padding: 10px 15px 0;
          font-size: 16px;
        }
        &:before{ border-color: transparent transparent transparent #bf802a; }
      }
    }
  }

  .service-max-paxluggage {
    font-size: 12px;
    line-height: 12px;
    margin-bottom: 10px;

    .pax-luggage{
      display: inline-block;

      a{
        color: inherit!important;
        span { text-decoration: underline; }
      }
    }
    .stairs-label{
      display: inline-block;
      padding: 3px 5px;
      color: #838d98;
      font-weight: 600;
    }
    .reach-max{ color:#ea4242; }
    .fa-stack{ margin-right: 5px; }
    span{ margin-right: 15px; }
  }
  .service-name {
    font-size: 26px;
    font-weight: 700;
    margin-bottom:5px;
    line-height: 18px;
  }
  .ribbon-label{
    font-size: 10px;
    vertical-align: 3px;
    background: #ff393b;
    color: #fff;
    padding: 3px 5px;
    border-radius: 4px;
    font-weight: 100;
    margin-left: 5px;
    text-transform: uppercase;
  }
  .service-desc-excerpt, .service-desc{
    color: #838d98;
    line-height: 125%;
    margin-bottom: 7px;
  }
  .service-desc-more{
    font-size: 13px;
    font-weight: 600;
    color: #923BBD;
    transition:all .3s ease;
  }

  .service-quote{ padding: 0 10px; }
  .service-price {
    font-size: 28px;
    font-weight: 600;
    color: #923BBD;
    line-height: 1;
    text-align: right;

    .shared-error{
      font-size: 13px;
      color: #ff4a4a;
      line-height: 1.4
    }
    .suggested-service{
      font-size: 14px;
      color: #2c3e50;
      line-height: 1.4;
      margin-top:10px;
      cursor:pointer;
      text-decoration: underline;
    }
  }
  .availability-error{
    font-size: 18px;
    text-align: right;

    span{
      display: block;
      line-height: 1;
      font-weight: 600;
      word-spacing: 5px;
    }
  }
  .service-discount-info{
    text-align: right;

    span{ display: inline-block; }
    .service-original-price{
      font-size: 18px;
      margin-right: 5px;
      position: relative;
      color: #ccc;
      vertical-align: middle;

      &:after{
        content: '';
        border-bottom:1px solid rgba(255,0,0, .5);
        position: absolute;
        top:50%;
        left: 0;
        width: 100%;
      }
    }
    .service-discount-saved{
      font-size: 12px;
      color: #fff;
      background: #d55556;
      padding: 2px 4px;
      vertical-align: middle;
      border-radius: 3px;
    }
  }
  .service-discount-timer{
    margin-top:10px;
    color: #777;
    text-align: right;

    div{
      font-size: 12.9px;
      line-height: 1;
      color: #999;
    }
    .timer{
      font-size:14px;
      display: block;
      line-height: 1.5;
    }
  }

  .eta{
    text-align: right;

    span{ display: block; }
    .minutes-away, .no-cars{
      font-size: 13px;
      color: #aaa;
    }
    .suggested-pickup-time{
      font-size: 14px;
      padding-top: 12px;

      &.not-allowed{ color: #ea4242; }
      div{
        font-size: 12px;
        font-style: italic;
      }
      a{
        text-decoration: underline;
        font-weight: 600;
      }
      i{
        margin-left: 3px;
        vertical-align: 1px;
      }
    }
    .dropoff-time{
      line-height: 1.1;
      font-size: 14px;
      color: #777;
    }
    .no-cars{ font-style: italic; }
  }

  .mng{
    text-align: right;
    font-size: 13px;
    color: #ea5427;
  }

  .loader-box{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background: rgba(0,0,0, 0);
    transition: all .3s ease-in;

    &.show{
      z-index: 3;
      background: rgba(0,0,0, .4);
    }
    .spinner-box{
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -18px;
      margin-top: -18px;
    }
    .fa-spinner{
      font-size: 36px;
    }
  }
}

.disabled-date{
  font-style: italic;
  font-weight: 600;
  text-align: center;
}

.medium-below{
  .icon-font, .logo{ text-align: center!important; }
  &.pricing{
    margin-bottom: 15px;

    .service-quote{ padding: 0; }
    .service-price{
      text-align: center;
      margin: 10px 0;
      font-size:28px;

      .shared-error{ margin-top: 5px; }
    }
    .service-discount-timer{
      margin-top: 3px;
      line-height: 10px;
      span{ font-size:12px!important; }
    }
    .service-discount-info, .service-discount-timer{ text-align: center; }
  }
  .one-way-fare.plus{
    margin-top: 10px;
  }
  &.service-desc-more{ clear:both; }
  .eta, .mng, .availability-error{ text-align: center; }
  .ribbon{
    position: absolute;
    top: -10px;
    right: 20px;

    img{
      position: relative;
      z-index: 2;
      width: 60px;
    }
    span{
      position: absolute;
      top: 3px;
      z-index: 3;
      width: 100%;
      right: 0;
      padding: 0 7px;
      line-height: 1.2;
      color: #fff;
      font-size: 11px;
    }
    &:before{
      content: '';
      border-style: solid;
      border-width: 9px 0 0 8px;
      position: absolute;
      z-index: 3;
      left: 100%;
      top: 0;
    }
    &.lowest{
      z-index: 5;
      &:before{ border-color: transparent transparent transparent #a54041; }
    }
    &.fastest{
      z-index: 4;
      span{ padding: 7px 5px 0; }
      &:before{ border-color: transparent transparent transparent #bf802a; }
    }
  }
  &.service-brand{ text-align: center;}
}

.more-imgs-link{
  cursor: pointer;
  text-decoration: underline;
}

.service-brand {
  .icon-font{
    text-align: left;
    font-size: 15px;
    margin-bottom: 10px;
    position: relative;

    &.pts-logo{ color: #D8262C!important; }
    &.opoli-logo{ color: #13bcac!important; }
    &.opoli-logo:after{
      background-image: url('../../assets/img/dresscode.png');
      background-size: 20px;
      display: inline-block;
      width: 20px;
      height: 20px;
      content: '';
      position: absolute;
      top: -3px;
      left: 88px;
    }
    &.s2l-logo{ color: #c165ef!important; }
  }
  .logo{
    margin-bottom: 10px;
    display: inline-block;
    img { width: 90px; }
  }
  .stairs-label{
    margin-bottom: 10px;
    display: inline-block;
    color: #fff;
    padding: 2px 7px;
    font-size: 12px;
    font-weight: bold;
    line-height: 1.1;
    border-radius: 2px;
    box-shadow: 1px 1px 0 rgba(0,0,0, .2);
  }
}
.stairs-label{
  display: inline-block;
  color: #fff;
  padding: 2px 7px;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.1;
  border-radius: 2px;
  box-shadow: 1px 1px 0 rgba(0,0,0, .2);
}

.rt-dc-small{
  position: relative;
  display: inline-block;

  img {
    position: relative;
  }
  span{
    position: absolute;
    z-index: 1;
    color: #fff;
    font-weight: 600;
    font-size: 16px;
    right: 50%;
    top: 50%;
    transform: translate(50%, -8px);
  }
}

@media only screen and (max-width: 641px) {
  .services{
    margin-top: 30px;
  }
  .service-img {
    position: relative!important;
    top:0!important;
    left: 0!important;
    transform: translateY(0)!important;
  }
  .service-max-paxluggage{
    text-align: center;
    margin-bottom: 20px!important;
    .pax-luggage{ padding: 0 5px; }
    span{
      margin: 0!important;
      max-width: 60px;
      display: inline-block;
      vertical-align: middle;
    }
  }
  .service-name{
    font-size: 24px!important;
    line-height: 1.1!important;
    margin-bottom:0!important;
    text-align:center;
    clear: both;
  }
  .pts-widget{
    .service-name{ margin-bottom: 10px!important; }
    .one-way-fare{ margin-top: 10px!important; }
  }
  .service-desc-more{ text-align:center; }
}

.one-way-fare{
  padding-top: 1px;
  padding-bottom: 1px;
  font-size: 12px;
  color: #999;

  &.plus{
    font-weight: 500;
    font-style: italic;
  }
}

.zznot_applicable{
  .ribbon{ display: none; }
}

.bounce-down-enter-active, .bounce-down-leave-active {
  transition-delay: .3s;
  transition: all .6s ease;
}
.bounce-down-enter, .bounce-down-leave-to {
  transform: scale(1.5);
  opacity: 0;
}

.slide-up-enter-active, .slide-up-leave{
  max-height: 1999px;
  transition: all 1s;
}
.slide-up-enter,.slide-up-leave-active{
  max-height: 0;
  opacity: 0;
  transition: all 1s;
}

.slide-down-enter-active, .slide-down-leave-active { transition: all .3s ease; }
.slide-down-enter, .slide-down-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

.fade-enter-active { transition: all .35s ease; }
.fade-leave-active { transition: all .15s ease; }
.fade-enter, .fade-leave-to { opacity: 0; }
</style>



// WEBPACK FOOTER //
// Services.vue?e782579e